<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>VR digital twin</h1>
        </div>
        <div class="video">
          <div class="">
            <video src="../assets/502sim.mp4" controls muted>
              OMG! Where is my video?
            </video>
          </div>
        </div>
        <div class="abstract">
          When working in Zetong Building, Zhejiang University, I casually built a VR office where I can grab my computer screen and display it on the computer in VR. I made the modeling and textures for the table and room myself.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="sub-title">
          Derivative works: A digital twin for my house
        </div>
        <div class="text">
          I also made a digital twin for my house. I have to say that it is totally a huge project because I didn't major in architecture. But I still modeling the whole house all by myself with the engineering drawings I borrowed from the estate developer. I have tried my best to restore the internal structure, external features, and interior of the house. It feels weird but amazing when I observe this digital house in VR just in my real house. It's like parallel spacetime really exists.
          <br /><br />
          When I gave this digital twin to my parents who live in this house to play with, their favorite operation was to transfer it directly from the balcony on the second or third floor to the ground on the first floor. This kind of operation that breaks social rules or physiological limitations can bring them great joy.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="picture">
          <img src="../assets/project2_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project2",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 15px;
  color: #666;
  font-weight: 400;
  text-align: justify;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
video {
  width: 100%;
}
.grid-content {
  min-height: 36px;
}
.video {
  margin-top: 100px;
}
.picture {
  margin-top: 0;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title a {
  color: #333;
}
.title p {
  color: #aaa;
  line-height: 30px;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 6px;
  color: #333333;
}
</style>
